import { Component, EventEmitter, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoginMainComponent } from '@common-components/login/login-main/login-main.component';

@Component({
  selector: 'app-login-popup',
  standalone: true,
  imports: [
    LoginMainComponent,
    MatDialogModule
  ],
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.scss']
})
export class LoginPopupComponent {
  readonly dialog = inject(MatDialog);

  data = inject(MAT_DIALOG_DATA);

  dialogRef: MatDialogRef<LoginPopupComponent>;
  isPopUpOpen = false;
  onAdd = new EventEmitter();

  ngOnInit() { }

  onButtonClick() {
    this.onAdd.emit();
  }

}
